import { motion } from "framer-motion";
import { MaskLines, Eyebrow } from "./Reveal";

const EASE = [0.22, 1, 0.36, 1];

export const PageHero = ({ eyebrow, lines, intro, testid }) => (
  <section data-testid={testid} className="relative bg-paper text-ink pt-40 pb-20 sm:pt-48 sm:pb-28 overflow-hidden">
    <div className="pointer-events-none absolute -right-40 -top-40 w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,rgba(29,63,168,0.10),transparent_65%)]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8 lg:px-12">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="mt-8 font-display font-extrabold tracking-[-0.035em] leading-[0.95] text-5xl sm:text-6xl lg:text-8xl">
        <MaskLines lines={lines} />
      </h1>
      {intro && (
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.6, duration: 0.8 }}
          className="mt-10 max-w-2xl text-base sm:text-lg text-ink/70 leading-relaxed"
        >
          {intro}
        </motion.p>
      )}
    </div>
  </section>
);
